<template>
  <div class="placeme1">
    <b-button variant="cart-button"
              aria-haspopup="true"
              class="img-icon img-icon-cloud-data-download-2 nav-link pr-2"
              data-toggle="dropdown">
      <b-badge variant="light" class="badge-sm badge-floating border-white badge-danger" v-if="$store.getters['entities/urls'].length > 0">{{ $store.getters['entities/urls'].length }}</b-badge>
    </b-button>
    <div class="dropdown-menu dropdown-menu-right">
      <div class="dropdown-header" v-if="$store.getters['entities/urls'].length > 0">
        <h5 class="text-overflow m-0">Entity Download Status</h5>
        <b> {{ $store.getters['entities/urls'].length }} files </b> |
        <b> {{ $store.getters['entities/urls'].filter((download)=>download.status === 'done').length }} completed</b> |
        <b> {{ $store.getters['entities/urls'].filter((download)=>download.status === 'progress').length }} progressing</b> |
        <b> {{ $store.getters['entities/urls'].filter((download)=> download.status === 'pending').length }} pending</b>
        <div v-if="$store.getters['entities/urls'].length > 0">
          <div class="list-group">
            <div v-for="download in $store.getters['entities/urls']" :key="download.signedUrl" class="mx-0 p-0 py-1">
              <entity-download :download="download"></entity-download>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center p-1">
        No Downloaded Files
      </div>
    </div>
  </div>
</template>

<script>

import EntityDownload from './EntityDownload.vue';

export default {
  components: { EntityDownload },
};
</script>

<style scoped>
.badge {
  padding: 0.15rem 0.150rem;
  background-color: rgb(133, 243, 247);
}
.badge-floating {
  position: absolute;
  top: -70%;
  transform: translateY(50%);
  border: 2px solid;
  right: -8px;
}
</style>
